import { createContext } from "react";

export const JourneyDataContext = createContext();
